import merge from 'lodash/merge';
import { CoreConfig } from '@react-awesome-query-builder/core';
import { colorPalette, themeOptions } from '@qualifio/ui-commons';

export type Operator = keyof CoreConfig['operators'];

export const excludedOperators: Operator[] = ['proximity', 'starts_with', 'ends_with'];

export const referralExcludedOperators: Operator[] = [
  'proximity',
  'starts_with',
  'ends_with',
  'equal',
  'like',
  'not_equal',
  'not_like',
  'is_null',
  'is_not_null',
];

export const isTestUserExcludedOperators: Operator[] = [
  'proximity',
  'like',
  'not_like',
  'is_null',
  'is_not_null',
  'is_empty',
  'is_not_empty',
  'not_equal',
];

export const emailExcludedOperators: Operator[] = [
  'proximity',
  'like',
  'not_like',
  'is_null',
  'is_not_null',
  'is_empty',
  'is_not_empty',
];

export const queryBuilderTheme = merge(themeOptions, {
  components: {
    MuiInput: {
      styleOverrides: {
        root: {
          height: '37px',
          color: colorPalette.grey.dark,
          padding: '8.5px 14px',
          '&:before': {
            border: 'none !important',
          },
          '&:after': {
            border: 'none !important',
          },
        },
        input: {
          padding: 0,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          border: `1px solid ${colorPalette.grey.main}`,
          borderRadius: '5px',
        },
        icon: { right: '7px' },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          div: {
            border: `1px solid ${colorPalette.grey.main}`,
            borderRadius: '5px',
          },
          marginTop: 'initial',
          input: {
            color: colorPalette.grey.dark,
            '&::placeholder': {
              color: colorPalette.grey.mainHover,
              opacity: 1,
            },
          },
        },
      },
    },
  },
});
